import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { PUBLIC_ROUTES } from './system/core/public.routes';
import { PRIVATE_ROUTES } from './system/core/private.routes';
import { PRIVATE_REDIRECT_ROUTES } from './system/core/private-redirect.routes';

export const routes: Routes = [
  ...PUBLIC_ROUTES,
  ...PRIVATE_REDIRECT_ROUTES,
  ...PRIVATE_ROUTES
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true, enableTracing: false, preloadingStrategy: NoPreloading}),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }


